/*
 * assets/vp-loadmore.js
 * Botão "Carregar mais" independente por seção, usando a Section
 * Rendering API do Shopify (?section_id=...&page=N) via fetch em
 * segundo plano — nunca navega a página nem mexe na URL visível.
 *
 * Depois de adicionar os novos cards, chama window.__vpRescanFilter
 * (se existir, de vp-filtro.js) pra essa seção — assim o filtro passa
 * a enxergar TODOS os produtos já carregados, não só os da primeira leva.
 */
(function () {
  if (window.__vpLoadMoreInit) return;
  window.__vpLoadMoreInit = true;

  function initLoadMore(wrap) {
    var btn = wrap.querySelector('.vp-loadmore-btn');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var url = wrap.getAttribute('data-next-url');
      var sectionId = wrap.getAttribute('data-section-id');
      if (!url || !sectionId) return;

      var sep = url.indexOf('?') > -1 ? '&' : '?';
      var fetchUrl = url + sep + 'section_id=' + encodeURIComponent(sectionId);

      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = 'Carregando...';

      fetch(fetchUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newCards = doc.querySelectorAll('.vp-card');
          var wrapper = document.getElementById('shopify-section-' + sectionId);
          var grid = wrapper ? wrapper.querySelector('.vp-grid, .vp-carousel') : null;

          if (grid && newCards.length) {
            newCards.forEach(function (card) { grid.appendChild(card); });
          }

          var newWrap = doc.querySelector('[data-vp-loadmore][data-section-id="' + sectionId + '"]');
          var newNextUrl = newWrap ? newWrap.getAttribute('data-next-url') : null;

          if (newNextUrl) {
            wrap.setAttribute('data-next-url', newNextUrl);
            btn.disabled = false;
            btn.textContent = originalText;
          } else {
            wrap.parentNode.removeChild(wrap);
          }

          if (window.__vpRescanFilter && window.__vpRescanFilter[sectionId]) {
            window.__vpRescanFilter[sectionId]();
          }
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = originalText;
        });
    });
  }

  function init() {
    document.querySelectorAll('[data-vp-loadmore]').forEach(initLoadMore);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
